import { connect } from "react-redux";

import { setBackdrop } from "../../../actions/appEngine";
import {
	setCarrierSettingEditData,
	setCarrierSettingId,
	setRulePriority,
} from "../../../actions/carrierSettings";
import { setUser } from "../../../actions/user";
import {
	createAutoAssignCarrier,
	deleteAutoAssignCarrier,
	getAllModeLists,
	getAutoAssignCarrier,
	optSecureShipment,
	updateAutoAssignCarrier,
	updateRule,
} from "../../../apilist";
import SetRulesCarriers from "../components/SetRules";

const mapDispatchToProps = {
	optSecureShipment,
	setBackdrop,
	setUser,
	getAutoAssignCarrier,
	updateAutoAssignCarrier,
	createAutoAssignCarrier,
	deleteAutoAssignCarrier,
	getAllModeLists,
	updateRule,
	setCarrierSettingEditData,
	setRulePriority,
	setCarrierSettingId,
};

const mapStateToProps = (state) => ({
	user: state.user,
	appEngine: state.appEngine,
	pickup: state.pickup,
});

const containerCreator = connect(mapStateToProps, mapDispatchToProps);

export const CarriersRules = containerCreator(SetRulesCarriers);
